import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { operations, selectors } from './duck';
import Presenter from './presenter';

const mapStateToProps = (state, props) => ({
  derived: {
    cities: selectors.selectCities(state),
    cuisines: selectors.selectCuisines(state),
    dishTags: selectors.selectDishTags(state),
    eateries: selectors.selectEateries(state),
    story: selectors.selectStory(state, props),
    isSaving: selectors.selectIsSaving(state),
    editedSlug: selectors.selectEditedSlug(state)
  },
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(operations, dispatch),
});

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(Presenter);

export default Container;
